import { createFileRoute } from '@tanstack/react-router';

// relative imports
import LoadingPage from '../../../../../../../../components/shared/page-components/LoadingPage';
import ExchangePage from '../../../../../../../../components/source-management/exchanges/exchange-page/ExchangePage';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange',
)({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: ExchangePage,
  staticData: {
    isClientRoute: true,
    meta: {
      title: 'Client Exchange Details | Ledgible',
    },
  },
});
